import React from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  FormField,
  Input,
  Select,
  Spinner,
  SegmentedControl,
  Header,
  Alert
} from "@amzn/awsui-components-react";

const CustomizeTabsModal = ({
  visible,
  onDismiss,
  modalLoading,
  errorText,
  allTabs,
  allCustomTabs,
  hiddenTabs,
  selectedTabControlsSegmentId,
  setSelectedTabControlsSegmentId,
  newTabName,
  setNewTabName,
  selectedUpdateOrDeleteTab,
  setSelectedUpdateOrDeleteTab,
  updateTabNameInput,
  setUpdateTabNameInput,
  selectedTabToUnhide,
  setSelectedTabToUnhide,
  onAddTab,
  onUpdateTab,
  onDeleteTab,
  onUnhideTab
}) => {
  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
      footer={
        <>
          {errorText && (
            <Alert type="error" statusIconAriaLabel="Error">
              {errorText}
            </Alert>
          )}
          {allTabs?.length >= 1 && (
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={onDismiss}>Cancel</Button>
                {selectedTabControlsSegmentId === 'add' && (
                  <Button variant="primary" onClick={onAddTab}>Add tab</Button>
                )}
                {selectedTabControlsSegmentId === 'update' && (
                  <Button variant="primary" onClick={onUpdateTab}>Update tab</Button>
                )}
                {selectedTabControlsSegmentId === 'delete' && (
                  <Button variant="primary" onClick={onDeleteTab}>Delete tab</Button>
                )}
                {selectedTabControlsSegmentId === 'unhide' && (
                  <Button variant="primary" onClick={onUnhideTab}>Unhide tab</Button>
                )}
              </SpaceBetween>
            </Box>
          )}
        </>
      }
      header="Customize Tabs"
    >
      {(allTabs?.length >= 1 && modalLoading === false) ? (
        <>
          <SegmentedControl
            selectedId={selectedTabControlsSegmentId}
            onChange={({ detail }) => setSelectedTabControlsSegmentId(detail.selectedId)}
            label="Modify Tabs"
            options={[
              { text: "Add tab", id: "add", iconName: "add-plus" },
              { 
                text: "Update tab", 
                id: "update", 
                iconName: "edit", 
                disabled: allCustomTabs?.length <= 0, 
                disabledReason: "No custom tabs available"
              },
              { 
                text: "Delete tab", 
                id: "delete", 
                iconName: "remove", 
                disabled: allCustomTabs?.length <= 0, 
                disabledReason: "No custom tabs available"
              },
              { 
                text: "Unhide tab", 
                id: "unhide", 
                iconName: "unlocked", 
                disabled: hiddenTabs?.length <= 0, 
                disabledReason: "No tabs hidden"
              },
            ]}
          />
          
          {selectedTabControlsSegmentId === 'add' && (
            <>
              <Header variant="h3">
                <Box color="text-status-info">Add new custom tab</Box>
              </Header>
              <FormField label="Tab name">
                <Input 
                  onChange={({ detail }) => setNewTabName(detail.value)}
                  value={newTabName}
                  placeholder='Provide a tab name'
                />
              </FormField>
            </>
          )}
          
          {selectedTabControlsSegmentId === 'update' && (
            <>
              <Header variant="h3">
                <Box color="text-status-info">Update existing custom tab</Box>
              </Header>
              <FormField label="Tab to update">
                <Select
                  selectedOption={selectedUpdateOrDeleteTab}
                  onChange={({ detail }) => setSelectedUpdateOrDeleteTab(detail.selectedOption)}
                  options={allCustomTabs?.map((tab) => ({ "label": tab, "value": tab }))}
                  empty="No custom tabs"
                  placeholder='Select document or tracker to update'
                />
              </FormField>
              {selectedUpdateOrDeleteTab && (
                <FormField label="New tab name">
                  <Input 
                    onChange={({ detail }) => setUpdateTabNameInput(detail.value)}
                    value={updateTabNameInput}
                    placeholder='Provide a tab name' 
                  />
                </FormField>
              )}
            </>
          )}

          {selectedTabControlsSegmentId === 'delete' && (
            <>
              <Header variant="h3">
                <Box color="text-status-info">Remove existing custom tab</Box>
              </Header>
              <FormField label="Tab to remove">
                <Select
                  selectedOption={selectedUpdateOrDeleteTab}
                  onChange={({ detail }) => setSelectedUpdateOrDeleteTab(detail.selectedOption)}
                  options={allCustomTabs?.map((tab) => ({ "label": tab, "value": tab }))}
                  placeholder='Select custom tab to remove'
                  empty="No custom tabs"
                />
              </FormField>
            </>
          )}

          {selectedTabControlsSegmentId === 'unhide' && (
            <>
              <Header variant="h3">
                <Box color="text-status-info">Unhide hidden custom tab</Box>
              </Header>
              <FormField label="Tab to unhide">
                <Select
                  selectedOption={selectedTabToUnhide}
                  onChange={({ detail }) => setSelectedTabToUnhide(detail.selectedOption)}
                  options={hiddenTabs?.map((tab) => ({ "label": tab, "value": tab }))}
                  placeholder='Select tab to unhide'
                  empty="No hidden tabs"
                />
              </FormField>
            </>
          )}
        </>
      ) : (
        <>
          <Spinner />Loading...
        </>
      )}
    </Modal>
  );
};

export default CustomizeTabsModal;
